import React from 'react';

// 红黄牌原因由口哨记录和单人操作共用，确保选项与手动输入行为一致。
const CARD_REASONS = ['抱怨裁判', '故意手球', '严重犯规', '鸣哨后射门', '队长失职'];

const CardReasonPicker = ({ cardReason, customReason, onReasonChange, onCustomChange, danger = false }) => (
    <>
        <div className="pitch-action-section-title"><span>2</span>选择犯规原因</div>
        <div className={`referee-record-reason-grid${danger ? ' danger' : ''}`}>
            {CARD_REASONS.map(reason => (
                <button
                    key={reason}
                    type="button"
                    className={cardReason === reason && !customReason.trim() ? 'active' : ''}
                    onClick={() => { onReasonChange(reason); onCustomChange(''); }}
                >
                    {reason}{cardReason === reason && !customReason.trim() && <span>✓</span>}
                </button>
            ))}
        </div>
        <input
            className="referee-record-reason-input"
            value={customReason}
            placeholder="或手动输入其他原因"
            aria-label="其他犯规原因"
            onChange={event => onCustomChange(event.target.value)}
        />
    </>
);

export default CardReasonPicker;
